module.exports = __webpack_public_path__ + "static/media/imghands.fbefd858.png";